import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { InterestDto } from '@sweatpals/shared';
import FitnessIcon from '../../images/Fitness-icon';
import { SkillLevelEnum } from '../../../enums/skill-levels';
import { SKILL_LEVEL_NAMES } from '../../../constants';

export interface IFitnessTypeBadgeProps {
	fitnessType?: InterestDto;
	masteryLevel?: number;
}

export const FitnessTypeBadge: FC<IFitnessTypeBadgeProps> = ({ fitnessType, masteryLevel }) => {
	const { name, id } = fitnessType ?? {};

	return (
		<Box
			sx={{
				display: 'flex',
				flexFlow: 'row nowrap',
				alignItems: 'center',
				gap: '12px',
				p: '13px 23px',
				borderRadius: '100px',
				backgroundColor: 'rgba(250, 250, 250, 0.1)',
			}}
		>
			<FitnessIcon
				fitnessTypeId={id}
				sx={{
					width: '24px',
					height: '24px',
				}}
			/>
			<Typography
				sx={{
					fontFamily: 'Integral CF',
					fontSize: '14px',
					fontWeight: 500,
					lineHeight: '17px',
					whiteSpace: 'nowrap',
					color: '#FFFFFF',
				}}
			>
				{name}
			</Typography>
			<Box
				title={
					masteryLevel
						? masteryLevel > SkillLevelEnum.Advanced
							? SKILL_LEVEL_NAMES[SkillLevelEnum.Advanced]
							: SKILL_LEVEL_NAMES[masteryLevel]
						: SKILL_LEVEL_NAMES[SkillLevelEnum.Beginner]
				}
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '4px',
					width: '18px',
				}}
			>
				{[SkillLevelEnum.Advanced, SkillLevelEnum.Intermediate, SkillLevelEnum.Beginner].map((skillLevel) => (
					<Box
						key={skillLevel}
						sx={{
							backgroundColor: '#FFFFFF',
							opacity: masteryLevel >= skillLevel ? 1 : 0.2,
							minHeight: '2.5px',
							borderRadius: '2px',
						}}
					></Box>
				))}
			</Box>
		</Box>
	);
};
